import { Component } from '@angular/core';

@Component({
	selector: 'ae-empty-route',
	templateUrl: './empty-route.component.html',
	styleUrls: ['./empty-route.component.scss'],
})
export class EmptyRouteComponent {}
